const appendStyle = url => {
  const widgetCssLink = document.createElement('link')
  widgetCssLink.type = 'text/css'
  widgetCssLink.rel = 'stylesheet'
  widgetCssLink.href = url
  document.head.appendChild(widgetCssLink)
}

export default appendStyle
